module.exports = __webpack_public_path__ + "media/images/icon-benefits-telemedecine-399a7352d41a012ded7e7523e1c1043d.png";